import { useState } from 'react'

import { Grid, Step, StepLabel, Stepper } from '@material-ui/core'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import Loader from 'Components/UI/Atoms/Loader'
import PictureCardWithZoom from 'Components/UI/Atoms/PictureCard/PictureCardWithZoom'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { styles } from 'Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Files/Tabs/MainPhotos/styles'
import DeleteAdditional from 'Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Files/Tabs/ReviewPhotos/DeleteAdditional'
import DialogUpload from 'Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Files/Tabs/ReviewPhotos/UploadAdditional'
import { useKeyPressEvent } from 'react-use'
import { interfaces } from 'service/interfaces'

import { MainPhotos } from './Main'
import { UploadPhotos } from './UploadPhotos'

const Steps = (props) => {
  const { open, handleClose } = props
  const createDismissableSnackbar = useCustomSnackbar()

  const [initValues, setInitValues] = useState(open)
  const [step] = useState(0)
  const [tab, setTab] = useState(0)
  const [loadingSearch, setLoadingSearch] = useState(false)
  const [change, setChange] = useState(
    open.data.revisionPhotos.length === 0 ? ['', '', '', '', '', ''] : open.data.revisionPhotos
  )
  const [dataActions1, setDataActions1] = useState({})
  const [change1, setChange1] = useState([])
  const classes = styles()
  const steps = ['Fotografías principales', 'Fotografías extras']

  function handleReplace(index, arr) {
    let imgUp = URL.createObjectURL(arr)
    open.data.revisionPhotos[index] = imgUp
  }

  async function handleSubmitUpload(value, index) {
    setLoadingSearch(true)
    await interfaces.vehicleInterface
      .uploadPhoto(value, index + 1, open.data.dominio, 'revision')
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        handleReplace(index, value)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      })
    setLoadingSearch(false)
  }

  function handleOpenDelete(data, index, openRemove) {
    setDataActions1({
      data: data,
      index: index,
      openRemove: openRemove,
      id: initValues.data.vehiculo_id,
    })
  }

  function handleOpenUpload() {
    setDataActions1({
      openUpload: true,
      id: initValues.data.vehiculo_id,
    })
  }
  function handleChange1(e) {
    e.preventDefault()
    let prevData = [...change1]
    let files = e.target.files
    for (let i = 0; i < files.length; i++) {
      prevData[i] = files[i]
    }
    setChange1(prevData)
  }

  function handleCloseActions1() {
    setChange1([])
    setDataActions1({
      openUpload: false,
      openRemove: false,
      id: null,
    })
  }

  function handleDeleteContext1(index) {
    let delet = index - 1
    initValues.data.revision_extra.splice(delet, 1)
  }

  function handleAdd(arr) {
    for (let i = 0; i < arr.length; i++) {
      let imgUp = URL.createObjectURL(arr[i])
      initValues.data.revision_extra.push(imgUp)
    }
  }

  async function handleSubmitAdditional(value) {
    setLoadingSearch(true)
    let index = initValues.data.revision_extra.length + 1
    await interfaces.vehicleInterface
      .uploadAdditionalPhotosRevision(value, index, initValues.data.dominio)
      .then((res) => {
        createDismissableSnackbar(`${res.data.data}`, {
          variant: 'success',
        })
        handleAdd(value)
        handleCloseActions1()
      })
      .catch(() => {
        createDismissableSnackbar('Error', {
          variant: 'error',
        })
        handleCloseActions1()
      })
    setLoadingSearch(false)
  }

  async function handleDeleteAdditional(arr, index) {
    setLoadingSearch(true)
    if (arr !== '' && arr !== undefined) {
      await interfaces.vehicleInterface
        .deleteFile('revisionextras', index, initValues.data.dominio)
        .then((res) => {
          createDismissableSnackbar(res.data, {
            variant: 'success',
          })
          handleDeleteContext1(index)
          handleCloseActions1()
        })
        .catch((error) => {
          createDismissableSnackbar(error.response.data.data, {
            variant: 'error',
          })
          handleCloseActions1()
        })
    } else {
      createDismissableSnackbar('Esta foto no existe! ', {
        variant: 'error',
      })
      handleCloseActions1()
    }
    setLoadingSearch(false)
  }

  function extraImageUrl(index) {
    return open.data.revision_extra[index]?.replace(
      /(\/revisionextras\/\d+)\/[^/]+\.webp$/,
      '$1.webp'
    )
  }

  function extractExtraDateFromUrl(index) {
    const fecha = open.data.revision_extra[index]?.match(/\/(\d{2}-\d{2}-\d{4})\.webp$/)?.[1]
    return fecha?.replace(/-/g, '/')
  }

  const swipes = open.data.revision_extra.map((item, index) => ({
    id: index,
    img: extraImageUrl(index),
  }))

  const _renderForms = (index) => {
    switch (index) {
      case 0:
        return (
          <>
            {loadingSearch && <Loader />}
            <InputsWithoutValidate
              fields={MainPhotos(open, handleClose, setInitValues)}
              spacing={3}
            />
            <UploadPhotos change={change} setChange={setChange} onSubmit={handleSubmitUpload} />
          </>
        )
      case 1:
        return (
          <Grid container alignContent="center" justify="center" spacing={2}>
            <Grid item xs={12} xl={12} sm={12} md={12} className={classes.container}>
              <CustomButton
                onClick={() => handleOpenUpload()}
                text="Agregar fotografías adicionales"
                className={classes.cardSelectImg}
                size="small"
              />
            </Grid>
            {open.data.revision_extra
              ?.filter((item) => item !== '')
              .map((item, index) => (
                <Grid item xs={12} xl={12} sm={12} md={12} className={classes.root2}>
                  <PictureCardWithZoom
                    img={extraImageUrl(index)}
                    edit={true}
                    txt={`Adicional ${index + 1} - ${extractExtraDateFromUrl(index) || ''}`}
                    title={`Adicional ${index + 1} - ${extractExtraDateFromUrl(index) || ''}`}
                    index={index + 1}
                    swipes={swipes}
                    handleDelete={() => handleOpenDelete(item, index + 1, true)}
                  />
                </Grid>
              ))}
          </Grid>
        )

      default:
        break
    }
  }
  useKeyPressEvent('Enter', () => (!disabledSubmit() ? handleSubmit() : null))

  // async function confirm() {
  //   setLoadingSearch(true)
  //     await interfaces.dashboardInterface
  //       .uploadPhotosRevision(open.data.dominio, change, 1)
  //       .then((res) => {
  //         createDismissableSnackbar(`${res.data.data}`, {
  //           variant: "success",
  //         })
  //         handleClose()
  //         setLoadingSearch(false)
  //       })
  //       .catch((error) => {
  //         createDismissableSnackbar(error.response.data.data, {
  //           variant: "error",
  //         })
  //         handleClose()
  //         setLoadingSearch(false)
  //       })
  // }

  async function handleSubmit() {
    if (tab === 1) {
      setLoadingSearch(true)
      setLoadingSearch(false)
      handleClose()
    } else {
      setTab(tab + 1)
    }
  }

  function disabledSubmit() {
    switch (tab) {
      case 0:
        return change.some((item) => item === '')
      case 1:
        return false
      default:
        return false
    }
  }

  function handlePrev() {
    if (tab !== 0) {
      setTab(tab - 1)
    } else {
      handleClose()
    }
  }

  return (
    <>
      <DialogComponent
        open={open}
        handleclose={tab === 2 ? null : () => handleClose({ code: '' })}
        widthLarge="500px"
        title="Subir fotografías de revisión"
        maxHeight
        disableBackdropClick={step > 0 ? true : false}
        disableEscapeKeyDown={step > 0 ? true : false}
        children={
          <>
            <Stepper
              alternativeLabel
              activeStep={tab}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0,
                paddingBottom: 20,
              }}
            >
              {steps
                .filter((e) => e !== '')
                .map((label, index) => (
                  <Step key={index}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
            </Stepper>
            <div style={{ height: '555px' }}>{_renderForms(tab)}</div>
          </>
        }
        actions={
          <CancelConfirmButtons
            onClickSubmit={handleSubmit}
            onClickCancel={handlePrev}
            submitText={tab === steps.length - 1 ? 'Confirmar' : 'Siguiente'}
            cancelText={tab === 0 ? 'Cancelar' : 'Atrás'}
            disabledSubmit={disabledSubmit()}
          />
        }
      />

      <DialogUpload
        open={dataActions1.openUpload}
        handleClose={handleCloseActions1}
        onSubmit={handleSubmitAdditional}
        handleChange={handleChange1}
        change={change1}
        loading={loadingSearch}
      />

      <DeleteAdditional
        data={dataActions1}
        open={dataActions1.openRemove}
        handleClose={handleCloseActions1}
        onSubmit={handleDeleteAdditional}
        loading={loadingSearch}
      />
    </>
  )
}

export default Steps
